import { DeliveryProviderPortalService } from '../api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal';
import { FlagValues } from '../api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/models';
import { ExperimentData } from './ExperimentRegistry';
import { CommonApplicationServices } from './CommonApplicationServices';

export class GlobalTargetingService {
  //add your own api client here
  private readonly deliveryProviderPortalApiClient: DeliveryProviderPortalService.ApiClient;
  private commonAppServices: CommonApplicationServices;

  constructor(commonAppServices: CommonApplicationServices) {
    this.commonAppServices = commonAppServices;
    this.deliveryProviderPortalApiClient = this.commonAppServices.apiClient.deliveryProviderPortal;
  }

  public async getGlobalExperiments(): Promise<ExperimentData> {
    //add your own experiments here
    const globalExperiments: ExperimentData = {
      ...(await this.getUserAbTestExperiments()),
      ...(await this.getTargetingValuesForProvider()),
    };
    return globalExperiments;
  }

  public async getGlobalFeatureFlags(): Promise<FlagValues> {
    const featureFlags: FlagValues = {
      ...(await this.getUserFeatureFlags()),
      ...(await this.getProviderFeatureFlags()),
    };
    return featureFlags;
  }

  // add private methods to execute api calls to get global experiments
  private async getUserAbTestExperiments(): Promise<ExperimentData | undefined> {
    // Wrap your api call in a try catch
    try {
      const response = await this.deliveryProviderPortalApiClient.getUserAbTestExperiment();
      if (!response) {
        return undefined;
      }
      return {
        user_ab_test_experiments: response.experiment_data || {},
      };
    } catch (_error) {
      return undefined;
    }
  }
  private async getTargetingValuesForProvider(): Promise<ExperimentData | undefined> {
    const experiments: ExperimentData = {};

    // ✅ Access selected provider via commonAppServices
    const selectedProviderData = this.commonAppServices.accountService.getSelectedProviderData$();
    const selectedProvider = selectedProviderData.state;

    if (!selectedProvider || !selectedProvider.providerId) {
      return undefined;
    }

    try {
      const response = await this.deliveryProviderPortalApiClient.getTargetingValuesForProvider({
        provider_id: selectedProvider.providerId,
        city_id: selectedProvider.cityId,
        country_code: selectedProvider.countryCode,
        signup_source: selectedProvider.signup_source,
        provider_status: selectedProvider.lifecycle_status,
      });
      if (!response) {
        return undefined;
      }
      for (const key in response.parameters.provider_onboarding) {
        experiments[key] = response.parameters.provider_onboarding[key];
      }
      return experiments;
    } catch (_error) {
      return undefined;
    }
  }

  private async getUserFeatureFlags(): Promise<FlagValues | undefined> {
    const featureFlags: FlagValues = {};
    const response = await this.deliveryProviderPortalApiClient.getUserFeatureFlags();
    if (!response) {
      return undefined;
    }
    for (const key in response.feature_flags) {
      featureFlags[key] = response.feature_flags[key];
    }
    return featureFlags;
  }

  private async getProviderFeatureFlags(): Promise<FlagValues | undefined> {
    const featureFlags: FlagValues = {};
    // ✅ Access selected provider via commonAppServices
    const selectedProviderData = this.commonAppServices.accountService.getSelectedProviderData$();
    const selectedProvider = selectedProviderData.state;

    if (!selectedProvider || !selectedProvider.providerId) {
      return undefined;
    }
    try {
      const response = await this.deliveryProviderPortalApiClient.getTargetingValuesForProvider({
        provider_id: selectedProvider.providerId,
        city_id: selectedProvider.cityId,
        country_code: selectedProvider.countryCode,
        signup_source: selectedProvider.signup_source,
        provider_status: selectedProvider.lifecycle_status,
      });
      if (!response) {
        return undefined;
      }
      for (const key in response.parameters.delivery_provider_portal_flags) {
        featureFlags[key] = response.parameters.delivery_provider_portal_flags[key];
      }
      return featureFlags;
    } catch (_error) {
      return undefined;
    }
  }
}
